export function isEmpty(str:string): boolean {
  return str.length === 0 || str.trim().length === 0;
}
